import { NgModule } from '@angular/core';
import { BigCurrencyPipe } from './big-currency.pipe';

@NgModule({
  declarations: [BigCurrencyPipe],
  imports: [
  ],
  exports: [BigCurrencyPipe]
})
export class BigCurrencyModule { }
